module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "session-timeout-dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Your session is about to expire.")]), _vm._v(" "), _c('p', [_vm._v("Redirecting in "), _c('span', {
    staticClass: "countdown-holder"
  }, [_vm._v(_vm._s(_vm.secondsToSessionEnd) + "s")]), _vm._v(" seconds.")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar--yellow progress-bar-striped countdown-bar active",
    style: (_vm.progressBarStyles),
    attrs: {
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "countdown-holder"
  }, [_vm._v(_vm._s(_vm.secondsToSessionEnd) + "s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "id": "session-timeout-dialog-logout",
      "type": "button"
    },
    on: {
      "click": _vm.emitLogout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "id": "session-timeout-dialog-keepalive",
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitRefresh
    }
  }, [_vm._v("Stay Connected")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("SESSION TIMEOUT NOTIFICATION")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c27b768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SessionTimeoutModal.vue
// module id = 1612
// module chunks = 1